<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article id="post-2252" class="post-2252 page type-page status-publish hentry">
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <img class="aligncenter size-full hc-managed-firewall-img" src="/static/assets/images/personal_cyber_harassments.png" />
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <h2 class="wow fadeIn">Sign In - Personal</h2>
                    <div role="form" class="wpcf7" dir="ltr" lang="en-US">
                      <div class="screen-reader-response"></div>
                      <form action="#" method="post" class="wpcf7-form" novalidate="novalidate">
                        <div class="hostcluster-contact row">
                          <div class="col-md-12">
                            <label>
                              E-mail
                              <span class="wpcf7-form-control-wrap email">
                                <input
                                  name="email"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Enter your email"
                                  type="email"
                                />
                              </span>
                            </label>
                          </div>
                          <div class="col-md-12">
                            <label>
                              Password
                              <span class="wpcf7-form-control-wrap email">
                                <input
                                  name="password"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Enter your password"
                                  type="password"
                                />
                              </span>
                            </label>
                          </div>
                          <div class="col-md-12 text-right">
                            <a href="">Forgot your password?</a>
                          </div>
                          <div class="col-md-12">
                            <input
                              value="SIGN IN"
                              class="wpcf7-form-control wpcf7-submit"
                              type="submit"
                            />
                            <span class="ajax-loader"></span>
                          </div>
                          <div class="col-md-12" style="margin: 10px 0px;">
                            Don't have an account yet? <a href="/personal_sign_up">Sign Up</a>
                          </div>
                        </div>
                        <div class="wpcf7-response-output wpcf7-display-none"></div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your IP",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "personal_harassment",
  data() {
    console.log("load", this.$store.state);
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/personal_sign_up.vue